import { ModalWindow } from "../modal/ModalWindow";
import { Map } from "./Map";
import React, {useState} from "react";

interface MapProps {
    lat?: number,
    lng?: number,
    polygon?: {lat: number, lng: number }[],
    onPolygonChange?: (polygon:{lat: number, lng: number }[]) => void,
    setMarker?: (m:{lat: number, lng: number}) => void
    onClose: (reason?:string) => void,
    contentBefore?: React.ReactNode,
    contentAfter?: React.ReactNode,
    onLocationSelect?: (position:{address: string}) => void
    maxWidth?: number
    minWidth?: number
    address?: string
}


export function MapDialog({
                              polygon,
                              address,
                              onPolygonChange,
                              contentBefore,
                              setMarker,
                              contentAfter,
                              lat,
                              lng,
                              onClose,
                              onLocationSelect,
                              maxWidth,
                              minWidth
}: MapProps) {

    const [loading, setLoading] = useState(false);

    return (
        <ModalWindow title={address} onClose={onClose} maxWidth={maxWidth} loading={loading} minWidth={minWidth}>
            {contentBefore}
            <Map polygon={polygon}
                 onPolygonChange={onPolygonChange}
                 setMarker={setMarker}
                 marker={lat !== undefined && lng !== undefined ? { lat, lng } : undefined}
                 onClose={onClose}
                 onLocationSelect={onLocationSelect}
                 externalLoading={setLoading}
            />
            {contentAfter}
        </ModalWindow>
    );
}